// extracted by mini-css-extract-plugin
module.exports = {"input":"Percentage_input__19VEZ","text":"Percentage_text__2A-zQ"};